var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"timeline-header-item"},[_c('div',{staticClass:"item-label",class:_vm.timelineHeaderClass},[_vm._v(_vm._s(_vm.timelineHeaderLabel))]),_vm._v(" "),_c('quarters-header-sub-item',{attrs:{"timeframe-item":_vm.timeframeItem,"current-date":_vm.currentDate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }